import * as tslib_1 from "tslib";
import setClauseValue from '../actions/setClauseValue';
import getCustomIcon from '../actions/helpers/getCustomIcon';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import store from '../store/store';
import { getMoveToMenuProps } from 'owa-mail-moveto-control';
import createNewFolder from '../actions/createNewFolderInboxRules';
import getFolderFromId from '../utils/folderTypeConversionUtil';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import setFocusedClauseId from '../actions/helpers/setFocusedClauseId';
var styles = require('./InboxRuleClause.scss');
var DEFAULT_MAX_FOLDERS = 8;
var InboxRulesFolderDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRulesFolderDropdown, _super);
    function InboxRulesFolderDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getFoldersForMoveTo = function (search, maxItems) {
            search = (search || '').trim().toLocaleLowerCase();
            maxItems = maxItems || DEFAULT_MAX_FOLDERS;
            var hasExactMatch = false;
            var isSearchTextPresent = search.length > 0;
            var ruleFolders = isSearchTextPresent
                ? _this.getFilteredFolders(search)
                : store.contextMenuFolders;
            var folders = [];
            for (var _i = 0, ruleFolders_1 = ruleFolders; _i < ruleFolders_1.length; _i++) {
                var folder = ruleFolders_1[_i];
                var folderName = folder.displayName;
                // Parent folder Id can be null if folder is root, and parent folder is not necessarily in
                // the folder table (mru can be out of sync because of desktop deletion)
                var parentFolderId = folder.parentFolderId;
                var parentFolder = parentFolderId ? getFolderFromId(parentFolderId) : null;
                // We have an exact match if the search string is non-empty and it matches a folder
                // at the root of the mailbox
                if (isSearchTextPresent &&
                    parentFolderId == folderNameToId('msgfolderroot') &&
                    folderName.toLocaleLowerCase() == search) {
                    hasExactMatch = true;
                }
                folders.push({
                    folderId: folder.folderId,
                    displayName: folderName,
                    parentFolderId: parentFolderId,
                    parentFolderDisplayName: parentFolder ? parentFolder.displayName : null,
                });
            }
            if (search) {
                _this.sortByDisplayName(folders);
                _this.sortByPrefixMatch(folders, search);
            }
            return {
                folders: folders.slice(0, maxItems),
                hasExactMatch: hasExactMatch,
            };
        };
        _this.getFilteredFolders = function (searchText) {
            var filteredFolders = [];
            for (var _i = 0, _a = store.contextMenuFolders; _i < _a.length; _i++) {
                var folder = _a[_i];
                // non-mail folders will be shown in search results without check (e.g. calendar folder)
                var folderName = folder.displayName.toLocaleLowerCase();
                if (folderName.indexOf(searchText) >= 0) {
                    filteredFolders.push(folder);
                }
            }
            return filteredFolders;
        };
        // logic copied from getFoldersForMoveTo in owa-mail
        _this.sortByDisplayName = function (array) {
            array.sort(function (folder1, folder2) {
                return folder1.displayName.localeCompare(folder2.displayName);
            });
        };
        // logic copied from getFoldersForMoveTo in owa-mail
        _this.sortByPrefixMatch = function (array, searchText) {
            array.sort(function (folder1, folder2) {
                var folder1Name = folder1.displayName.toLocaleLowerCase();
                var folder2Name = folder2.displayName.toLocaleLowerCase();
                var folder1IsPrefixMatch = folder1Name.indexOf(searchText) == 0;
                var folder2IsPrefixMatch = folder2Name.indexOf(searchText) == 0;
                // Sort array so that folders with prefix match shows first
                if (folder1IsPrefixMatch && !folder2IsPrefixMatch) {
                    return -1;
                }
                else if (!folder1IsPrefixMatch && folder2IsPrefixMatch) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
        };
        return _this;
    }
    InboxRulesFolderDropdown.prototype.render = function () {
        var _this = this;
        var currentSelectedFolder = store.inboxRulesEditState.clauseMap.get(this.props.clauseId)
            .clauseValue;
        var moveToFolderProps = getMoveToMenuProps(true /* shouldShowSearchBox */, 'RuleOptions', createNewFolder, function () {
            // we must explicitly call dismissMenu from the button ref because it does not close when focus is lost
            _this.buttonRef.dismissMenu();
            setFocusedClauseId(_this.props.clauseId, false /* shouldSetAsFocused */);
        }, function () {
            return store.contextMenuFolders;
        }, this.getFoldersForMoveTo, function (folderId) {
            setClauseValue(getFolderFromId(folderId), _this.props.clauseId);
        }, null /* getFocusedOtherMenuItems */, getCustomIcon, 1 /* topCenter */, true /* useTargetWidth */, true /* coverTarget */);
        var buttonStyles = {
            root: styles.categoryMoveToPickerButton,
            label: currentSelectedFolder
                ? styles.categoryMoveToPickerText
                : styles.categoryMoveToPickerPlaceholderText,
        };
        return (React.createElement(DefaultButton, { componentRef: function (ref) {
                _this.buttonRef = ref;
            }, styles: buttonStyles, className: styles.categoryMoveToPickerButton, menuProps: moveToFolderProps, text: currentSelectedFolder
                ? currentSelectedFolder.displayName
                : strings.ruleSelectFolder, iconProps: currentSelectedFolder && {
                iconName: getCustomIcon(currentSelectedFolder.folderId, true),
            } }));
    };
    InboxRulesFolderDropdown = tslib_1.__decorate([
        observer
    ], InboxRulesFolderDropdown);
    return InboxRulesFolderDropdown;
}(React.Component));
export default InboxRulesFolderDropdown;
//# sourceMappingURL=FolderClauseValue.js.map